import styled from 'styled-components';
import { s14, s24, r, b, s18 } from '@theswing/rhythm';

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;
  padding-bottom: calc(80px + constant(safe-area-inset-bottom));
  padding-bottom: calc(80px + env(safe-area-inset-bottom));

  & a {
    color: inherit;
    text-decoration: none;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;

  & > .title {
    display: flex;
    flex-direction: column;
    & > .main {
      ${s24};
      ${b};
      color: ${(props) => props.theme.colors.black};
      margin: 8px 0 0 0;
    }
    & > .sub {
      ${s14};
      ${r};
      color: ${(props) => props.theme.colors.g600};
    }
  }
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  & > * {
    padding-bottom: 20px;
  }
`;

export const GuideContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  & > .title {
    ${s18};
    ${b};
    color: ${(props) => props.theme.colors.black};
    padding: 16px 20px;
  }

  & > .content {
    ${s14};
    ${r};
    color: ${(props) => props.theme.colors.g600};
    word-break: keep-all;
    white-space: pre-wrap;
    padding: 8px 20px;
  }
`;